import { Component, computed, inject, input } from '@angular/core';

import { OfferSimpleListItem, OfferStatus, StatusChangeType } from '@core/offers-types';
import {
  JobActionsFacade,
  StatusesDropdownContainerDataService,
  StatusChangeFacade,
} from '@recruitee/offers-logic';
import { StatusesDropdownComponent } from '@recruitee/offers-ui';

@Component({
  selector: 'rt-statuses-dropdown-container',
  imports: [StatusesDropdownComponent],
  template: `
    <rt-statuses-dropdown
      [offer]="offer()"
      [state]="state()"
      [hasPublishActions]="hasPublishActions()"
      [isPlain]="isPlain()"
      (action)="action($event)"
    ></rt-statuses-dropdown>
  `,
})
export class StatusesDropdownContainerComponent {
  private readonly statusChangeFacade = inject(StatusChangeFacade);
  private readonly jobActionsFacade = inject(JobActionsFacade);
  private readonly statusesDropdownContainerDataService = inject(
    StatusesDropdownContainerDataService,
  );

  public offer = input.required<OfferSimpleListItem>();
  public isPlain = input(true);

  protected hasPublishActions = computed(
    () => this.hasPublishJobs() && this.offer().status !== OfferStatus.Archived,
  );
  protected state = computed(() => (this.hasManageJobs() ? 'default' : 'read-only'));

  private hasManageJobs = this.statusesDropdownContainerDataService.canManageJobs;
  private hasPublishJobs = this.statusesDropdownContainerDataService.hasPublishJobs;

  protected action(name: StatusChangeType) {
    switch (name) {
      case StatusChangeType.Publish:
        this.statusChangeFacade.setPublished(this.offer());
        break;
      case StatusChangeType.Unpublish:
        this.statusChangeFacade.setInternal(this.offer());
        break;
      case StatusChangeType.Close:
        this.statusChangeFacade.setClosed(this.offer());
        break;
      case StatusChangeType.Archive:
        this.jobActionsFacade.archive(this.offer());
        break;
      default:
        break;
    }
  }
}
